import { Lisio } from "../../lisio";

function lisioCloseMessageHandler(this: Lisio) {
  this.mutationObserverController.disconnectObserver();
  this.widget.closeWidget();
  this.mutationObserverController.connectObserver();
}

export { lisioCloseMessageHandler };
